import { Component, Inject, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { AuthService } from '../../../abstraction/auth.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataLayerService } from '../../../services/utils/data-layer.service';
import { AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms';
import errors from '../../../../core/utils/errorCodes';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  seeRepPassword = false;
  passwordControl = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
    Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=\-_!*()@%&.,?/|:<>~'"]).{8,}$/),
  ]);
  newPassword = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
    Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=\-_!*()@%&.,?/|:<>~'"]).{8,}$/),
    this.noRepeatControlValidator(this.passwordControl),
  ]);
  repeatNewPassword = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
    Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=\-_!*()@%&.,?/|:<>~'"]).{8,}$/),
    this.repeatControlValidator(this.newPassword),
  ]);

  controls = [this.passwordControl, this.newPassword, this.repeatNewPassword];
  controlNames = {
    password: this.passwordControl,
    newPass: this.newPassword,
    repeatNewPass: this.repeatNewPassword,
  };

  loading: boolean;
  pesoAdolar: boolean;
  amount: string;
  seePassword = false;

  constructor(
    private apiService: ApiService,
    public authService: AuthService,
    public dialog: MatDialog,
    public router: Router,
    public dataService: DataLayerService,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: string,
  ) {}

  ngOnInit(): void {}

  getErrorMessage(input: string) {
    const keys = Object.keys(this.controlNames[input].errors);
    if (keys.length === 0) {
      return '';
    }
    return errors[keys[0]];
  }

  checkForMatch(event: any) {
    const _element = event.target;
    if ((_element.value as string).length > 0) {
      _element.updateValueAndValidity();
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  invalidChangePass(): boolean {
    this.passwordControl.markAsDirty();
    this.newPassword.markAsDirty();
    this.repeatNewPassword.markAsDirty();
    return (
      this.newPassword.hasError('required') || this.newPassword.hasError('notRepeated'),
      this.repeatNewPassword.hasError('required') || this.repeatNewPassword.hasError('notRepeated')
    );
  }

  updatePassword() {
    this.seePassword = false;
    this.seeRepPassword = false;
    if (this.invalidChangePass()) {
      return;
    }
    this.authService.updatePassword(this.passwordControl.value, this.newPassword.value).subscribe(
      (data) => {
        this.dialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: 'Contraseña cambiada',
              content: `Tu contraseña fue cambiada exitosamente. Ya podés iniciar sesión con la nueva contraseña.`,
            },
          })
          .afterClosed()
          .subscribe((res) => {
            this.closeDialog();
            this.authService.logout();
          });
      },
      (err) => {
        this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title: 'Error cambiando contraseña',
            content: `Hubo un error al cambiar tu contraseña, por favor intentá nuevamente.`,
          },
        });
        console.log(err);
      },
    );
  }

  repeatControlValidator(repeatable: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
      control.value !== repeatable.value ? { notRepeated: true } : null;
  }

  noRepeatControlValidator(repeatable: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
      control.value === repeatable.value ? { passwordMatch: true } : null;
  }
}
